import { render, staticRenderFns } from "./ShopFilter.vue?vue&type=template&id=0c120ca8"
import script from "./ShopFilter.vue?vue&type=script&lang=js"
export * from "./ShopFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports